'use strict';

import execute_on from "../../../../libs/execute-on";
import {swalFire} from "../../../../plugins/sweet-alert/sweet-alert-default";
import 'jquery.repeater';

execute_on('admin.company.price-list', function() {
    $(".price-list-repeater").repeater({
        initEmpty: false,
        isFirstItemUndeletable: true,
        defaultValues: {},
        show: function () {
            $(this).slideDown()
        },
        hide: function (deleteElement) {
            swalFire({
                title: 'Delete price level',
                text: 'Are you sure you want to delete this price level?',
                icon: 'question',
            }).then((result) => {
                if (result.value === true) {
                    $(this).slideUp(deleteElement);
                }
            });
        },
    }).on('click', '[data-repeater-create]', function () {
        $(this).closest('.price-list-repeater')
            .find('[data-repeater-list] [data-repeater-item]:last-child input[disabled]')
            .removeAttr('disabled');
    });
});
